export default __webpack_public_path__ + "static/01_diss_cover_TOC.pdf";